<template>
  <div id="page-manajemen-antrean">
    <div class="col-md-12 no-padding pl-lg-0 pl-md-0 pr-0">
      <div
        class="card card-box"
        style="border-radius : 0%; height: 100%;  min-height: 650px;"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 mt-2 mb-3">
              <h4 class="__blue" style="font-weight: 700">
                Sistem Manajemen Antrean
              </h4>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div>
                <strong>Pilih Panggilan Antrean</strong>
              </div>
              <div>
                Silakan klik untuk mengaktifkan atau menonaktifkan fitur
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col">
              <b-form-checkbox
                v-model="checked"
                name="check-button"
                switch
                :disabled="!editMode"
                class="custom-switch"
              >
                <!-- <span
                  v-if="editMode"
                  class="toggle-icon"
                  :class="{ on: checked, off: !checked }"
                >
                  {{ checked ? "✔" : "✖" }}
                </span>
                <span
                  v-if="!editMode"
                  class="toggle-icon"
                  :class="{ on: checked, off: !checked }"
                >
                  {{ checked ? "✔" : "" }}
                </span> -->
                <b-alert
                  show
                  variant="dark"
                  class="alert-skema-komisi alert-radio-label my-0"
                  >Gunakan Panggilan Antrean</b-alert
                >
              </b-form-checkbox>
            </div>
          </div>
          <div v-if="pemanggilanAntrean">
            <div class="row mt-4">
              <div class="col">
                <strong>Link url Layar Panggilan Antrean:</strong>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col">
                <div class="blue-pill">
                  <a
                    :href="antreanLink"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="link"
                  >
                    {{ antreanLink }}
                  </a>
                  <font-awesome-icon
                    :icon="['far', 'copy']"
                    class="copy-icon"
                    @click="copyToClipboard"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col">
                <div class="alert alert-skema-komisi alert-dark">
                  <div class="row">
                    <div class="col">
                      <strong>Gunakan Panggilan Antrean</strong>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      Fitur yang mencakup pemanggilan antrean konsultasi ke
                      Dokter.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="row">
            <div class="col-md text-right">
              <b-button v-if="editMode" variant="primary" @click="onSubmit"
                >Simpan</b-button
              >
              <b-button
                v-if="!editMode"
                variant="primary"
                @click="editMode = true"
                >Edit Data</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
library.add(faCopy);

export default {
  data: () => {
    return {
      checked: false,
      editMode: false,
    };
  },
  mounted() {
    this.getProfile();
    
    window.scrollTo({
      top: 95,
      behavior: "smooth"
    });
  },
  computed: {
    ...mapGetters(["getKlinikId", "pemanggilanAntrean"]),
    antreanLink() {
      return `${process.env.VUE_APP_URL_PEMANGGILAN_ANTREAN}/#${this.pemanggilanAntrean}`;
    }
  },
  methods: {
    onSubmit() {
      this.$swal
        .fire({
          type: "warning",
          html:
            '<p class="m-0 text-bridging-bpjs">Apakah Anda yakin mengubah<br>pengaturan Sistem Manajemen Antrean?</p>',
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#1791EE"
        })
        .then(res => {
          if (res.value) {
            // this.btnDisable = true;
            this.submit();
          }
        });
    },
    async submit() {
      const res = await this.$axios.post(
        `klinik/set-pemanggilan-antrean?klinik_id=${this.getKlinikId}`,
        { pemanggilan_antrean: this.checked }
      );

      try {
        const { antrean_uuid } = res.data.data;

        this.$store.commit("SET_PEMANGGILAN_ANTREAN", antrean_uuid);

        this.$swal({
          type: "success",
          title: "Fitur Sistem Manajemen Antrean berhasil disimpan",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1791EE"
        }).then(res => {
          this.editMode = false;
          this.$swal.close();
        });
      } catch (error) {
        console.error(error);
      }
    },
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.antreanLink);
        alert("Tautan telah disalin."); // Optional: Show a success message
      } catch (err) {
        console.error("Gagal menyalin:", err);
      }
    },
    async getProfile() {
      try {
        let profile;
        this.$store.state.klinikUser.map(data => {
          if (data.parent_id != null && data.id == this.getKlinikId) {
            profile = data.parent_id;
          }
        });
        const res = await this.$axios.get(
          `klinik/${this.getKlinikId}?klinik_id=${profile}&profile=true`
        );
        const { data } = res.data;
        
        this.$store.commit("SET_PEMANGGILAN_ANTREAN", data.antrean_uuid);
        
        if(data.antrean_uuid){
          this.checked = true;
        } 
        
      } catch (e) {}
    }
  }
};
</script>

<style scoped></style>

<style>
.__blue {
  color: #4b80b6;
}

.alert {
  border-radius: 5px;
}

.alert-radio-label {
  padding: 0.75rem 2rem;
  margin-right: 50px;
}

.alert-skema-komisi {
  background-color: #eeeff8;
  opacity: 1;
  top: -10px;
}

#page-manajemen-antrean
  .custom-control-input:checked
  ~ .custom-control-label::before {
  color: #fff;
  border-color: green;
  background-color: #0abc5a;
}

.blue-pill {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  background-color: #e8f1ff;
  border-radius: 25px;
  color: #1170fe;
  max-width: max-content;
  gap: 10px;
}

.link {
  font-size: 16px;
  word-break: break-all; /* Ensures long links break instead of overflowing */
}

.copy-icon {
  font-size: 22px;
  cursor: pointer;
  flex-shrink: 0; /* Prevents the icon from shrinking */
}

#page-manajemen-antrean .card-footer {
  border-top: none;
}

#page-manajemen-antrean
  .custom-switch
  .custom-control-input:checked
  ~ .custom-control-label::before {
  background-color: green;
  border-color: green;
}

#page-manajemen-antrean
  .custom-switch
  .custom-control-input:not(:disabled):not(:checked)
  ~ .custom-control-label::before {
  background-color: red;
  border-color: red;
}

#page-manajemen-antrean
  .custom-switch
  .custom-control-input:disabled:not(:checked)
  ~ .custom-control-label::before {
  background-color: #DADADA;
  border-color: #DADADA;
}

.custom-switch .custom-control-label::after {
  background-color: #fff;
}

.toggle-icon {
  position: absolute;
  top: 24%;
  z-index: 1;
  left: -49px;
  transform: translateY(-50%);
  font-size: 12px;
  font-weight: bold;
  transition: transform 0.15s ease-in-out, color 0.15s ease-in-out;
}

/* Saat tombol ON */
.toggle-icon.on {
  transform: translateX(22px) translateY(-50%);
  color: green;
}

/* Saat tombol OFF */
.toggle-icon.off {
  transform: translateX(0px) translateY(-50%);
  color: red;
}
</style>
